// src/api/queries/vacations.js
/**
 * Хуки отпусков. GET /vacations возвращает либо массив, либо
 * постраничный конверт { items, meta } — нормализуем через unwrapItems
 * (utils/dbShape.js) прямо в хуке. Escape hatch — свой select через options.
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";
import { unwrapItems } from "../../utils/dbShape";

export const VACATIONS_KEY = ["vacations"];

export function useVacationsQuery(options = {}) {
  return useQuery({
    queryKey: VACATIONS_KEY,
    queryFn: () => api.get("/vacations"),
    select: unwrapItems,
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useUpsertVacationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }) => {
      const payload = {
        startDate: body.start,
        endDate: body.end,
        type: body.type,
        comment: body.comment,
      };

      if (id) {
        return api.patch(`/vacations/${id}`, payload);
      }
      return api.post("/vacations", payload);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: VACATIONS_KEY });
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}

export function useDeleteVacationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/vacations/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: VACATIONS_KEY });
    },
  });
}

export function useDecideVacationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, approved, reason }) =>
      api.post(`/vacations/${id}/decide`, { approved, reason }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: VACATIONS_KEY });
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
